var featuredBlogsSwiper = null;

if (document.querySelector(".featured-blog-posts-swiper")) {
  featuredBlogsSwiper = new Swiper(".featured-blog-posts-swiper", {
    slidesPerView: 1,
    spaceBetween: 12,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpoints: {
      500: {
        slidesPerView: 2
      },
      800: {
        slidesPerView: 3
      },
      1000: {
        slidesPerView: 4
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  if (
    document.querySelector("#garageAjaxinateContainer") &&
    document.querySelector("#garageAjaxinatePagination")
  ) {
    new Ajaxinate({
      container: "#garageAjaxinateContainer",
      pagination: "#garageAjaxinatePagination",
      method: "scroll",
      offset: 1000
    });
  }

  function formatArticlePublishDates() {
    this.textContent = convertDateToText(this.textContent.split(" ")[0]);

    function convertDateToText(date) {
      return new Date(date).toLocaleString("en-us", {
        month: "short",
        day: "numeric"
      });
    }
  }

  // formatArticlePublishDates();

  function navigation(slider) {
    var wrapper, dots, arrowLeft, arrowRight;

    function markup(remove) {
      wrapperMarkup(remove);
      dotMarkup(remove);
      arrowMarkup(remove);
    }

    function removeElement(element) {
      if (element && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    }

    function createDiv(className) {
      var div = document.createElement("div");
      var classNames = className.split(" ");
      classNames.forEach(function (name) {
        div.classList.add(name);
      });
      return div;
    }

    function arrowMarkup(remove) {
      if (remove) {
        removeElement(arrowLeft);
        removeElement(arrowRight);
        return;
      }

      arrowLeft = createDiv("arrow arrow--left");
      arrowLeft.addEventListener("click", function () {
        slider.prev();
      });

      arrowRight = createDiv("arrow arrow--right");
      arrowRight.addEventListener("click", function () {
        slider.next();
      });

      wrapper.appendChild(arrowLeft);
      wrapper.appendChild(arrowRight);
    }

    function wrapperMarkup(remove) {
      if (remove) {
        var parent = wrapper.parentNode;
        while (wrapper.firstChild) {
          parent.insertBefore(wrapper.firstChild, wrapper);
        }
        removeElement(wrapper);
        return;
      }

      wrapper = createDiv("navigation-wrapper");
      slider.container.parentNode.appendChild(wrapper);
      wrapper.appendChild(slider.container);
    }

    function dotMarkup(remove) {
      if (remove) {
        removeElement(dots);
        return;
      }

      dots = createDiv("dots");
      slider.track.details.slides.forEach(function (_e, idx) {
        var dot = createDiv("dot");
        dot.addEventListener("click", function () {
          slider.moveToIdx(idx);
        });
        dots.appendChild(dot);
      });

      wrapper.appendChild(dots);
    }

    function updateClasses() {
      var slide = slider.track.details.rel;

      if (slide === 0) {
        arrowLeft.classList.add("arrow--disabled");
      } else {
        arrowLeft.classList.remove("arrow--disabled");
      }

      if (slide === slider.track.details.slides.length - 1) {
        arrowRight.classList.add("arrow--disabled");
      } else {
        arrowRight.classList.remove("arrow--disabled");
      }

      Array.prototype.forEach.call(dots.children, function (dot, idx) {
        if (idx === slide) {
          dot.classList.add("dot--active");
        } else {
          dot.classList.remove("dot--active");
        }
      });
    }

    slider.on("created", function () {
      markup();
      updateClasses();
    });

    slider.on("optionsChanged", function () {
      markup(true);
      markup();
      updateClasses();
    });

    slider.on("slideChanged", function () {
      updateClasses();
    });

    slider.on("destroyed", function () {
      markup(true);
    });
  }

  if (typeof KeenSlider !== "undefined" && document.querySelector("#my-keen-slider")) {
    new KeenSlider(
      "#my-keen-slider",
      {
        breakpoints: {
          "(min-width: 500px)": {
            slides: { perView: 2, spacing: 5 }
          },
          "(min-width: 800px)": {
            slides: { perView: 3, spacing: 10 }
          },
          "(min-width: 1000px)": {
            slides: { perView: 4, spacing: 10 }
          }
        },
        slides: { perView: 1 },
        loop: true
      },
      [navigation]
    );
  }

  function calcScrollValue() {
    var scrollProgress = document.getElementById("progress");
    var progressValue = document.getElementById("progress-value");
    var pos = document.documentElement.scrollTop;
    var calcHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    var scrollValue = Math.round((pos * 100) / calcHeight);

    if (!scrollProgress) {
      return;
    }

    if (pos > 100) {
      scrollProgress.style.display = "grid";
    } else {
      scrollProgress.style.display = "none";
    }

    scrollProgress.onclick = function () {
      document.documentElement.scrollTop = 0;
    };

    scrollProgress.style.background =
      "conic-gradient(#2863ec " + scrollValue + "%, #fff " + scrollValue + "%)";
  }

  window.onscroll = calcScrollValue;
  window.onload = calcScrollValue;
});